import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-homepageww',
  templateUrl: './homepageww.component.html',
  styleUrls: ['./homepageww.component.css']
})
export class HomepagewwComponent implements OnInit,AfterViewInit  {
  @Input()

  @ViewChild('content', { static: false, read: ElementRef }) elementView: ElementRef;  
  
  contentHeight: number;
  hei:string
  url1:string;
  url: string = environment.LINK_HOME_PAGE;
  urlSafe: SafeResourceUrl;
  environment=environment
  constructor(public sanitizer:DomSanitizer) { }
  ngAfterViewInit(): void {
    $( window ).height();
    //console.log(window.document.getElementById('main'))
      
  }

  ngOnInit() {
    const d = new Date();
    let timeAttuale = d.getTime();
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url+"?time="+timeAttuale);  
    //console.log(this.urlSafe);
    //if(environment.production==true){
     // this.url1=this.url
    //}
    
     
  }

}
